export default __webpack_public_path__ + "static/JohnHeadshot-9b91dabb3c8130dc76379c3bae97d0f1.jpg";